export const CustomerCDStorageChargeType = {
	none: 0,
	hours: 1,
	date: 2,
};

export const CustomerServiceChargeType = {
	kilo: 1,
	ppl: 2,
};

export const ChargeTypeByCode = {
	4600: CustomerServiceChargeType.ppl,
	4610: CustomerServiceChargeType.kilo,
	4620: CustomerServiceChargeType.ppl,
	4630: CustomerServiceChargeType.kilo,
};

export const CodeByChargeType = {
	[CustomerServiceChargeType.ppl]: [4600, 4620],
	[CustomerServiceChargeType.kilo]: [4610, 4630],
};

export const CustomerCCTOCDChangeType = {
	none: 0,
	minutes: 1,
};
